// Asset Type APIs
/**
 * @function ApiClient#GetAssetTypeList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetAssetTypeList(cid, options = {}) {
  return await this._get(`/community/${cid}/asset_type_list`, options);
}

/**
 * @function ApiClient#AddAssetType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} newItem
 * @param {any} options = {}
 */
export async function AddAssetType(cid, newItem, options = {}) {
  return await this._post(`/community/${cid}/asset_type`, newItem, options);
}

/**
 * @function ApiClient#UpdateAssetType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} itemList
 * @param {any} options = {}
 */
export async function UpdateAssetType(cid, itemList, options = {}) {
  return await this._put(`/community/${cid}/asset_type`, itemList, options);
}

/**
 * @function ApiClient#DeleteAssetType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} atID
 * @param {any} options = {}
 */
export async function DeleteAssetType(cid, atID, options = {}) {
  return await this._delete(`/community/${cid}/asset_type/${atID}`, options);
}

// Asset System APIs
/**
 * @function ApiClient#GetAssetSystemList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} atID
 * @param {any} options = {}
 */
export async function GetAssetSystemList(cid, atID, options = {}) {
  return await this._get(`/community/${cid}/asset_type/${atID}/system_list`, options);
}

/**
 * @function ApiClient#AddAssetSystem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} atID
 * @param {any} newItem
 * @param {any} options = {}
 */
export async function AddAssetSystem(cid, atID, newItem, options = {}) {
  return await this._post(`/community/${cid}/asset_type/${atID}/system`, newItem, options);
}

/**
 * @function ApiClient#UpdateAssetSystem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} atID
 * @param {any} itemList
 * @param {any} options = {}
 */
export async function UpdateAssetSystem(cid, atID, itemList, options = {}) {
  return await this._put(`/community/${cid}/asset_type/${atID}/system`, itemList, options);
}

/**
 * @function ApiClient#DeleteAssetSystem
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} atID
 * @param {any} stID
 * @param {any} options = {}
 */
export async function DeleteAssetSystem(cid, atID, stID, options = {}) {
  return await this._delete(`/community/${cid}/asset_type/${atID}/system/${stID}`, options);
}

// Asset Place APIs
/**
 * @function ApiClient#GetAssetPlaceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetAssetPlaceList(cid, options = {}) {
  return await this._get(`/community/${cid}/asset_place_list`, options);
}

/**
 * @function ApiClient#AddAssetPlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} placeName
 * @param {any} options = {}
 */
export async function AddAssetPlace(cid, placeName, options = {}) {
  return await this._post(`/community/${cid}/asset_place?p=${placeName}`, null, options);
}

/**
 * @function ApiClient#UpdateAssetPlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} places
 * @param {any} options = {}
 */
export async function UpdateAssetPlace(cid, places, options = {}) {
  return await this._put(`/community/${cid}/asset_place`, places, options);
}

/**
 * @function ApiClient#DeleteAssetPlace
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} placeName
 * @param {any} options = {}
 */
export async function DeleteAssetPlace(cid, placeName, options = {}) {
  return await this._delete(`/community/${cid}/asset_place?p=${placeName}`, options);
}

// Asset Management APIs
/**
 * @function ApiClient#GetAssetOverview
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetAssetOverview(cid, options = {}) {
  return await this._get(`/community/${cid}/asset_overview`, options);
}

/**
 * @function ApiClient#AddAsset
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} assetData
 * @param {any} imageFiles
 * @param {any} files
 * @param {any} options = {}
 */
export async function AddAsset(cid, assetData, imageFiles, files, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(assetData));

  if (imageFiles) {
    imageFiles.forEach((f) => {
      formData.append("Image", f);
    });
  }

  if (files) {
    files.forEach((f) => {
      formData.append("File", f);
    });
  }

  return await this._post(`/community/${cid}/asset`, formData, options);
}

/**
 * @function ApiClient#UpdateAsset
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} assetData
 * @param {any} imageFiles
 * @param {any} files
 * @param {any} options = {}
 */
export async function UpdateAsset(cid, assetData, imageFiles, files, options = {}) {
  const formData = new FormData();
  formData.set("Data", JSON.stringify(assetData));

  if (imageFiles) {
    imageFiles.forEach((f) => {
      formData.append("Image", f);
    });
  }

  if (files) {
    files.forEach((f) => {
      formData.append("File", f);
    });
  }

  return await this._put(`/community/${cid}/asset`, formData, options);
}

/**
 * @function ApiClient#DeleteAsset
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} assetID
 * @param {any} options = {}
 */
export async function DeleteAsset(cid, assetID, options = {}) {
  return await this._delete(`/community/${cid}/asset/${assetID}`, options);
}
